/* ==========================================================================
   C6 méga-menu · LE TIROIR À PANNEAUX (mobile, vague 2)
   --------------------------------------------------------------------------
   Un écran à la fois, poussé depuis la droite, retour nommé.

   Ce fichier ne fait QUE la pile d'écrans. L'ouverture et la fermeture du
   tiroir lui-même restent au thème : le composant `<menu-drawer>` porte
   déjà le voile, le blocage du défilement de la page, le piège à focus et le
   bouton hamburger. En réécrire un second aurait été s'engager à tenir les
   deux d'accord à jamais.

   Ce fichier ne contient AUCUN texte affichable.
   ========================================================================== */
(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════════════════
     LOT U · « QUAND JE FERME LE MÉGA-MENU MOBILE, DES FOIS ÇA AFFICHE UN
     ENCADRÉ AUTOUR DE DIMENSIONS, COMME SI C'ÉTAIT PRÉCHOISI. »
     ----------------------------------------------------------------------
     REPRODUIT LE 03/09 (`c6-v6-focus.mjs`), Chromium ET WebKit, 390 × 844,
     par un appui TACTILE dont les évènements souris de compatibilité sont
     supprimés - ce que Safari iOS fait régulièrement, notamment quand le
     doigt appuie pendant que la page glisse encore.

     LA CHAÎNE, EN TROIS MAILLONS, ET AUCUN N'EST UN BOGUE ISOLÉ :

     1. `theme.js` · `ModalComponent.focusElement` rend LE PREMIER `<button>`
        du tiroir, et `handleAfterShow` lui donne le focus par
        `a11y.trapFocus(this, this.focusElement)`. Faire entrer le focus dans
        une surcouche qui s'ouvre est CORRECT : sans cela, le lecteur d'écran
        et le clavier restent derrière le voile. Or le premier `<button>` du
        tiroir C6 est la première rangée d'« Explorer par », c'est-à-dire
        **Dimensions**. Personne n'a choisi Dimensions : c'est l'ordre du DOM.

     2. Le navigateur décide seul s'il PEINT un anneau, par `:focus-visible`.
        Sa règle : un focus posé par programme mérite un anneau tant que la
        dernière interaction n'était pas un pointeur. Sur un appui tactile
        dont les évènements souris sont supprimés, Chromium comme WebKit
        répondent `:focus-visible = true`. D'où le « des fois » de Raph :
        c'est le même geste, et le navigateur tranche différemment selon ce
        qu'il a vu passer juste avant.

     3. `.cmt-rang:focus-visible` peint alors 2 px de bruni autour de
        Dimensions - notre propre règle, et elle a raison au clavier. Le même
        enchaînement pose ensuite un anneau sur le ☰ lui-même à la fermeture,
        quand le thème lui rend le focus par `removeTrapFocus`.

     LA RÉPARATION, ET CE QU'ELLE NE FAIT PAS. On ne retire pas le focus du
     tiroir : ce serait casser le clavier et le lecteur d'écran pour un
     problème de peinture. On ne touche ni à `theme.js` ni à `theme.css`.
     On dit au CSS CE QUE LE NAVIGATEUR NE SAIT PAS : par quel geste le
     visiteur pilote la page à cet instant. `data-cm-saisie` vaut `pointeur`
     dès qu'un `pointerdown` passe, `clavier` dès qu'une touche de navigation
     est enfoncée. La feuille n'éteint l'anneau QUE sous `pointeur`, et la
     touche de tabulation repasse à `clavier` AVANT que le focus ne bouge :
     Tab montre donc toujours le focus.

     POURQUOI `pointerdown` ET NON `mousedown`. Le thème porte déjà un
     `focusVisiblePolyfill` qui écoute `mousedown` (`theme.js`). C'est
     exactement le maillon qui lâche ici : `mousedown` est un évènement de
     COMPATIBILITÉ que Safari iOS supprime parfois, tandis que `pointerdown`
     et `touchstart` sont les évènements natifs de l'appui et arrivent
     toujours. On écoute les deux, en capture et en passif. */
  var racineDoc = document.documentElement;
  var TOUCHES_NAV = {
    Tab: 1, Enter: 1, ' ': 1, Escape: 1, Home: 1, End: 1, PageUp: 1, PageDown: 1,
    ArrowUp: 1, ArrowDown: 1, ArrowLeft: 1, ArrowRight: 1
  };
  function saisie(mode) {
    if (racineDoc.getAttribute('data-cm-saisie') !== mode) racineDoc.setAttribute('data-cm-saisie', mode);
  }
  ['pointerdown', 'touchstart', 'mousedown'].forEach(function (ev) {
    document.addEventListener(ev, function () { saisie('pointeur'); }, { capture: true, passive: true });
  });
  document.addEventListener('keydown', function (ev) {
    if (TOUCHES_NAV[ev.key]) saisie('clavier');
  }, true);

  document.querySelectorAll('[data-cmt]').forEach(function (racine) {
    var racineEcran = racine.querySelector('[data-cmt-niveau="1"]');
    if (!racineEcran) return;

    /* La pile des écrans ouverts. Elle sert au retour : sans elle, revenir
       du niveau 3 refermerait aussi le niveau 2, et le visiteur retomberait
       à la racine au lieu de la liste des douze gammes. */
    var pile = [];

    function montre(nom) {
      var cible = racine.querySelector('[data-cmt-nom="' + nom + '"]');
      if (!cible) return;
      cible.classList.add('est-visible');
      racineEcran.classList.add('est-recule');
      pile.push(cible);
      /* On remet le nouvel écran en haut : sans cela, un écran déjà visité
         rouvre à la position de défilement où il a été quitté, ce qui donne
         au visiteur l'impression d'avoir atterri au milieu d'une liste. */
      cible.scrollTop = 0;
    }

    function recule() {
      var dernier = pile.pop();
      if (dernier) dernier.classList.remove('est-visible');
      if (!pile.length) racineEcran.classList.remove('est-recule');
    }

    racine.querySelectorAll('[data-cmt-vers]').forEach(function (b) {
      b.addEventListener('click', function () {
        montre(b.dataset.cmtVers);
      });
    });

    racine.querySelectorAll('.cmt-retour').forEach(function (b) {
      b.addEventListener('click', recule);
    });

    /* Échap remonte d'UN écran, pas jusqu'à la racine : c'est le même geste
       que le bouton de retour, et c'est ce que le visiteur attend. Quand il
       ne reste rien à remonter, on laisse le thème fermer le tiroir. */
    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape' || !pile.length) return;
      ev.stopPropagation();
      recule();
    });

    /* Le tiroir se rouvre toujours à sa racine. Un tiroir qui rouvre trois
       écrans plus loin est le défaut le plus courant de ce motif : le
       visiteur a fermé pour revenir en arrière, et il retrouve exactement ce
       qu'il fuyait. On écoute l'évènement du THÈME, pas un second nôtre. */
    document.addEventListener('menu-drawer:open', function () {
      while (pile.length) recule();
    });

    /* ── LE BANDEAU DE CONSENTEMENT, QUI RECOUVRAIT CINQ ENTRÉES ────────────
       Relevé le 01/09 sur l'aperçu réel, téléphone, session vierge : le
       bandeau Consentmo recouvre le bas du tiroir. C'est le blocage P0 ouvert
       depuis C4, et `DIRECTION.md` le donne pour non résolu par ce chantier.
       Il l'est ici, et sans écrire une seule règle neuve.

       La politique existe déjà, dans `casemira-tokens.css` : « une surcouche
       est ouverte, ce qui flotte s'efface », portée par la classe `cm-over`
       posée sur `<html>`. Elle a été écrite pour le lecteur vidéo, la feuille
       de filtres, la mini-fiche et le tiroir panier. Le tiroir de navigation
       est la cinquième surcouche plein écran du site, et personne ne la lui
       avait appliquée. Le bandeau est un élément à racine fantôme posé en
       `position: fixed` avec un `z-index` de 2 147 483 647 : aucun palier de
       profondeur ne peut passer devant, l'effacement est la seule réponse.
       Le bandeau revient intact à la fermeture, et le consentement n'est ni
       pris, ni contourné, ni présumé.

       On suit l'attribut `open` du composant du thème, qui est son état
       d'autorité : `menu-drawer:open` dit l'ouverture, rien ne dit la
       fermeture. */
    /* R1 · ON NE RETIRE QUE CE QU'ON A POSÉ (03/09).
       `cm-over` est partagée par cinq surcouches. Depuis la vague 6, la
       recherche FERME le tiroir quand elle s'ouvre : si la fermeture du
       tiroir retirait `cm-over` en aveugle, le bandeau de consentement et la
       pastille de chat reviendraient par-dessus les suggestions, une demi-
       seconde après qu'on les a demandées. C'est exactement la faute que
       `casemira-c6-loupe.js` avait corrigée dans l'autre sens en vague 4, et
       elle vaut ici mot pour mot : un bandeau de consentement qu'on oublie de
       RALLUMER est un défaut ; un bandeau qui se rallume par-dessus une
       surcouche vivante en est un autre. */
    /* `cmg-lock` : le guide des tailles des fiches couloir, pose par
       `casemira-guide-tiroir.js` (ajout C5, 05/09). `cmq-locked` : la
       mini-fiche des collections, posee par `casemira-collection-plus.js`
       (ajout C5, 05/09 - le panneau du mega-menu est en dessous de l'en-tete
       et laisse la grille cliquable, si bien qu'une mini-fiche peut vivre
       quand il se ferme). Meme forme que les autres revendicateurs, nomme un
       par un. */
    function quelquUnDAutreLaTient() {
      return (
        document.documentElement.classList.contains('cmk-open') ||
        document.documentElement.classList.contains('cmg-lock') ||
        document.documentElement.classList.contains('cmq-locked') ||
        /* `cmt-lock` : le guide des tailles des fiches HORS couloir (`casemira-guide-tailles.js`, ajout R5, 05/09). */
        document.documentElement.classList.contains('cmt-lock') ||
        document.body.classList.contains('search-open') ||
        document.body.classList.contains('search-is-open')
      );
    }

    var tiroir = racine.closest('menu-drawer');

    /* LOT U, SECOND MAILLON · LE TIROIR SE FERME, LE FOCUS RESTE DEDANS.
       `theme.js` pose `inert` sur le tiroir à la fermeture, et `inert` sort
       le focus tout seul - sur un navigateur qui le connaît. Safari ne le
       connaît que depuis la version 16.4, et le tiroir met 400 ms à sortir de
       l'écran : sur un iPhone resté en iOS 15, l'anneau de Dimensions
       accompagne donc le tiroir pendant toute sa sortie, ce qui est
       précisément l'instant que Raph décrit.

       On rend le focus au ☰, qui est le bouton d'où le visiteur vient et
       celui vers lequel le thème le ramène de son côté ; à défaut, on relâche
       simplement. Le `blur()` n'est pas de la politesse : sans lui, rendre le
       focus au ☰ pendant que le tiroir se referme laisserait le navigateur
       libre de le garder sur une rangée devenue invisible. */
    function rendLeFocus() {
      var actif = document.activeElement;
      if (!actif || !tiroir.contains(actif)) return;
      if (actif.blur) actif.blur();
      /* Trois boutons portent `aria-controls` vers ce tiroir - un pour le
         téléphone, deux pour l'ordinateur - et deux d'entre eux sont éteints
         par la requête de média. On prend celui qui est RENDU : un `focus()`
         sur un bouton en `display: none` ne fait rien, et le focus resterait
         alors sur un élément que l'on vient de quitter. */
      var ham = [].slice
        .call(document.querySelectorAll('[aria-controls="' + tiroir.id + '"]'))
        .filter(function (b) { return b.tagName === 'BUTTON' && b.offsetParent !== null; })[0];
      if (ham && ham.focus) ham.focus();
    }

    if (tiroir && 'MutationObserver' in window) {
      var applique = function () {
        var ouvert = tiroir.hasAttribute('open');
        if (ouvert) document.documentElement.classList.add('cm-over');
        else if (!quelquUnDAutreLaTient()) document.documentElement.classList.remove('cm-over');
        if (ouvert) recaleHauteur();
        else {
          tiroir.style.removeProperty('height');
          rendLeFocus();
        }
      };
      new MutationObserver(applique).observe(tiroir, { attributes: true, attributeFilter: ['open'] });
      applique();
    }

    /* ══════════════════════════════════════════════════════════════════════
       B8 · « J'OUVRE LE MENU, JE LE FERME, J'OUVRE UNE COLLECTION, JE
       ROUVRE LE MENU ET IL NE SE DÉPLOIE PAS EN ENTIER. »
       ----------------------------------------------------------------------
       LA CAUSE, REPRODUITE EN RECETTE LE 02/09 (c6-v3-check § B8).

       `theme.css` donne au tiroir sa hauteur par un calcul :

         .menu-drawer { position: absolute; top: 100%;
                        height: calc(var(--viewport-height)
                                     - var(--header-bottom-position)); }

       et `header.js` pose ces deux variables UNE SEULE FOIS, dans
       `prepareToShow()`, juste avant d'ouvrir :

         --viewport-height        = window.innerHeight
         --header-bottom-position = header.getBoundingClientRect().bottom

       Or l'en-tête de ce site SE CACHE À LA DESCENTE (acquis de C3). Sur une
       page de collection descendue, son bas relevé vaut 35 px au lieu de
       106 ; il revient à sa place en une transition dès que le doigt remonte.
       Le visiteur qui remonte et appuie sur le hamburger dans la seconde qui
       suit fait lire à `prepareToShow` un en-tête À MI-COURSE.

       RELEVÉ EXACT, iPhone 13 émulé, page de collection descendue à 1400 :
         --header-bottom-position = 35px   (en-tête à mi-course)
         bas réel de l'en-tête    = 106px  (une fois posé)
         hauteur du tiroir        = 664 - 35 = 629 px
         bas du tiroir            = 106 + 629 = 735 px, pour une fenêtre de 664
         → 71 px de tiroir SOUS la ligne de flottaison, inatteignables.

       Ce sont ces 71 px que Raph voit manquer. Et la valeur est écrite en
       style EN LIGNE sur `<html>` : elle survit à la fermeture, donc le
       tiroir reste faux tant qu'on ne réouvre pas depuis un en-tête posé.
       Ce n'est ni le bfcache, ni les View Transitions, ni une classe
       conservée : c'est UNE MESURE PRISE UNE FOIS, AU MAUVAIS INSTANT.

       LA RÉPARATION. On ne touche ni à `theme.css` ni à `header.js` - les
       deux servent aussi le tiroir de repli et trois autres surcouches. On
       mesure la GÉOMÉTRIE RÉELLE du tiroir une fois qu'il est posé, et on
       écrit sa hauteur en style en ligne sur l'élément lui-même, ce qui
       dépasse la règle de feuille sans jouer à la spécificité :

         hauteur = hauteur de la fenêtre − haut réel du tiroir

       C'est vrai quel que soit l'état de l'en-tête, puisque le haut du tiroir
       EST le bas de l'en-tête (le tiroir est en `top: 100%` de son
       conteneur). On repasse à la trame suivante, puis à 250 et 500 ms - le
       temps que la transition de l'en-tête finisse - puis à chaque
       redimensionnement et à chaque changement de la fenêtre visuelle, ce qui
       couvre la rotation et la barre d'adresse d'iOS qui se replie.

       Et on RETIRE la hauteur à la fermeture : rien ne doit rester d'un
       calcul fait pour un instant qui n'existe plus. */
    var recalage = null;
    function mesureUneFois() {
      if (!tiroir || !tiroir.hasAttribute('open')) return;
      var haut = tiroir.getBoundingClientRect().top;
      if (haut < 0) return;
      var h = Math.round(window.innerHeight - haut);
      if (h > 0) tiroir.style.height = h + 'px';
    }
    function recaleHauteur() {
      if (recalage) clearTimeout(recalage);
      requestAnimationFrame(mesureUneFois);
      recalage = setTimeout(function () {
        mesureUneFois();
        recalage = setTimeout(mesureUneFois, 250);
      }, 250);
    }
    window.addEventListener('resize', recaleHauteur);
    window.addEventListener('orientationchange', recaleHauteur);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', recaleHauteur);
    }
    document.addEventListener('menu-drawer:open', recaleHauteur);
  });
})();
